import {
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { getCollectionManagementById } from '../../../../../../../../lib/api/collections';
import ContactsDocument from '../../../../../../../../lib/common/ContactsDocument';
import CustomButton from '../../../../../../../../lib/designSystem/Button';
import CenteredCircularProgress from '../../../../../../../../lib/designSystem/CircularProgress';
import EnhancedTable from '../../../../../../../../lib/designSystem/Table';
import { cellFormat } from '../../../../../../../../lib/designSystem/Table/cellFormat';
import { LightTooltip } from '../../../../../../../../lib/designSystem/WhiteTooltip';
import { formatMoney } from '../../../../../../../../lib/functions/utils';
interface propsType {
  openModal: boolean;
  setOpenModal: any;
  collectionManagementId: number;
  handleComplete: any;
}

interface CollectionManagement {
  id: number;
  collectionManagementOptions: any[];
  folio: string;
  businessName: string;
  businessIdentifier: string;
  stakeholderName: string;
  stakeholderIdentifier: string;
  amount: number;
  dueAmount: number;
  dueDays: number;
  paymentDate: Date;
  completedAt: Date;
  description: string;
  companyId: number;
  createdAt: string;
  type: string;
  totalRemainingNet: number;
  state: string;
  name: string;
  option: string;
  optionName: string;
  updatedAt: string;
  dueDate: Date;
  stakeholderContacts: any[];
  businessContacts: any[];
  relatedManagements: any[];
}

const DetailedCollectionManagement: React.FC<propsType> = (
  props: propsType,
) => {
  const { collectionManagementId, openModal, setOpenModal, handleComplete } =
    props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [contactModal, setContactModal] = useState(false);
  const [collectionManagement, setCollectionManagement] =
    useState<CollectionManagement | null>(null);

  const fetchDetailedManagement = async () => {
    setLoading(true);
    try {
      const result = await getCollectionManagementById(
        dispatch,
        collectionManagementId,
      );
      setCollectionManagement(result);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchDetailedManagement();
  }, []);

  if (loading) return <CenteredCircularProgress type="dialog" />;

  if (!collectionManagement) return <div></div>;

  return (
    <Dialog maxWidth="xl" open={openModal} onClose={() => setOpenModal(false)}>
      <DialogTitle style={{ display: 'flex', justifyContent: 'space-between' }}>
        <span>Gestión de cobranza #{collectionManagement.id}</span>
        <Chip
          label={
            collectionManagement.completedAt ? 'Completada' : 'No completada'
          }
          style={{
            fontWeight: 'bold',
          }}
          color={collectionManagement.completedAt ? 'success' : 'warning'}
        />
      </DialogTitle>
      <DialogContent style={{ minWidth: '1000px' }}>
        <Grid container spacing={3}>
          <Grid item xs={4}>
            <Typography fontWeight="bold">Datos del documento</Typography>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                paddingTop: '12px',
              }}
            >
              <Typography>Folio</Typography>
              <Typography>{collectionManagement.folio}</Typography>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                paddingTop: '12px',
              }}
            >
              <Typography>Monto documento</Typography>
              <Typography>
                {formatMoney(collectionManagement.amount)}
              </Typography>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                paddingTop: '12px',
              }}
            >
              <Typography>Cliente</Typography>
              <Typography>{collectionManagement.businessName}</Typography>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                paddingTop: '12px',
              }}
            >
              <Typography>Rut Cliente</Typography>
              <Typography>{collectionManagement.businessIdentifier}</Typography>
            </div>

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                paddingTop: '12px',
              }}
            >
              <Typography>Deudor</Typography>
              <Typography>{collectionManagement.stakeholderName}</Typography>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                paddingTop: '12px',
              }}
            >
              <Typography>Rut Deudor</Typography>
              <Typography>
                {collectionManagement.stakeholderIdentifier}
              </Typography>
            </div>
          </Grid>
          <Grid item xs={4}>
            <div>
              <Typography fontWeight="bold">Datos de la gestión</Typography>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  paddingTop: '12px',
                }}
              >
                <Typography>Estado</Typography>
                <Typography>{collectionManagement.state}</Typography>
              </div>
              {collectionManagement.option && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    paddingTop: '12px',
                  }}
                >
                  <Typography>SubEstado</Typography>
                  <LightTooltip
                    title={
                      <Typography>{collectionManagement.optionName}</Typography>
                    }
                  >
                    <Typography>
                      {collectionManagement.optionName.slice(0, 10) +
                        (collectionManagement.optionName.length > 10
                          ? '...'
                          : '')}
                    </Typography>
                  </LightTooltip>
                </div>
              )}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  paddingTop: '12px',
                }}
              >
                <Typography>Tipo de gestión</Typography>

                <Typography>{collectionManagement.type}</Typography>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  paddingTop: '12px',
                }}
              >
                <Typography>Fecha de gestión</Typography>
                <Typography>
                  {cellFormat(collectionManagement.dueDate, 'due-date')}
                </Typography>
              </div>
            </div>
          </Grid>
          <Grid item xs={4}>
            <div>
              <Typography fontWeight="bold">Descripción</Typography>
              <Typography style={{ whiteSpace: 'pre-wrap' }}>
                {collectionManagement.description}
              </Typography>
            </div>
          </Grid>
        </Grid>
        <div style={{ marginTop: '20px' }}>
          <Typography fontWeight="bold">
            Gestiones pendientes relacionadas
          </Typography>
          <EnhancedTable
            dataHeaders={[
              { key: 'id', label: 'ID', type: 'numeric-id' },
              // ...(canHaveSubordinates
              //   ? [{ key: 'userOwnerName', label: 'Ejecutivo' }]
              //   : []),
              { key: 'elementType', label: 'Tipo', type: 'collection-type' },
              { key: 'description', label: 'Descripción' },
              { key: 'folio', label: 'Documento' },
              {
                key: 'businessName',
                label: 'Cliente',
                // handleAction: handleShowBusinessDetails,
                // icon: <Info fontSize="small" />,
              },
              {
                key: 'stakeholderName',
                label: 'Deudor',
                // handleAction: handleShowStakeholderDetails,
                // icon: <Info fontSize="small" />,
              },
              { key: 'dueDate', label: 'Fecha gestión', type: 'due-date' },
            ]}
            data={collectionManagement.relatedManagements}
            exportToFile="xlsx"
          />
        </div>
      </DialogContent>
      <DialogActions>
        <CustomButton color="secondary" onClick={() => setOpenModal(false)}>
          {' '}
          Cancelar{' '}
        </CustomButton>
        <CustomButton color="primary" onClick={() => setContactModal(true)}>
          Ver contactos
        </CustomButton>
        {!collectionManagement.completedAt && (
          <CustomButton
            color="success"
            onClick={() => handleComplete(collectionManagementId)}
          >
            Completar
          </CustomButton>
        )}
      </DialogActions>
      {contactModal && (
        <ContactsDocument
          openModal={contactModal}
          setOpenModal={setContactModal}
          businessName={collectionManagement.businessName}
          businessIdentifier={collectionManagement.businessIdentifier}
          stakeholderName={collectionManagement.stakeholderName}
          stakeholderIdentifier={collectionManagement.stakeholderIdentifier}
          businessContacts={collectionManagement.businessContacts}
          stakeholderContacts={collectionManagement.stakeholderContacts}
        />
      )}
    </Dialog>
  );
};

export default DetailedCollectionManagement;
